module.exports = __webpack_public_path__ + "static/media/ApplePie.fa194bf6.jpeg";